import { Avatar } from '../Avatar';
import type { CosmeticItem } from '../../api/types';
import { assetUrl } from './cosmeticsMap';
import { LottieLayer } from './LottieLayer';

/**
 * Аватар с рамкой Straddle Pass: холст рамки = диаметр фото ÷ 0,54, центр
 * совпадает с фото, overflow visible (кепка/корона выходят за кольцо).
 * Рамки играют циклом ВСЕГДА (README: исключение из режимов по редкости);
 * перфоманс списков держит IO-пауза внутри LottieLayer — офскрин не играет.
 */
export function CosmeticAvatar({
  name,
  src,
  size = 42,
  frame,
  bordered = false,
}: {
  name?: string | null;
  src?: string | null;
  size?: number;
  frame?: CosmeticItem | null;
  bordered?: boolean;
}) {
  const url = frame ? assetUrl(frame.asset) : null;
  if (!url) return <Avatar name={name} src={src} size={size} bordered={bordered} />;
  const canvas = Math.round(size / 0.54);
  return (
    <span className="cav" style={{ width: size, height: size }}>
      <Avatar name={name} src={src} size={size} bordered={false} />
      <LottieLayer src={url} mode="loop" className="cav-frame" width={canvas} height={canvas} />
    </span>
  );
}
